/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import type { UpdateScreenerSettingRequest } from './UpdateScreenerSettingRequest';
import {
    UpdateScreenerSettingRequestFromJSON,
    UpdateScreenerSettingRequestFromJSONTyped,
    UpdateScreenerSettingRequestToJSON,
} from './UpdateScreenerSettingRequest';

/**
 * 
 * @export
 * @interface FindAllScreenerAdmissionFlags200ResponseDataInner
 */
export interface FindAllScreenerAdmissionFlags200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    category: FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    created_at?: string;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    created_by_user?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    gender?: string | null;
    /**
     * 
     * @type {Array<UpdateScreenerSettingRequest>}
     * @memberof FindAllScreenerAdmissionFlags200ResponseDataInner
     */
    aliases?: Array<UpdateScreenerSettingRequest>;
}


/**
 * @export
 */
export const FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum = {
    Behavioral: 'Behavioral',
    Financial: 'Financial',
    Clinical: 'Clinical',
    Other: 'Other'
} as const;
export type FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum = typeof FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum[keyof typeof FindAllScreenerAdmissionFlags200ResponseDataInnerCategoryEnum];


/**
 * Check if a given object implements the FindAllScreenerAdmissionFlags200ResponseDataInner interface.
 */
export function instanceOfFindAllScreenerAdmissionFlags200ResponseDataInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "category" in value;

    return isInstance;
}

export function FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON(json: any): FindAllScreenerAdmissionFlags200ResponseDataInner {
    return FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerAdmissionFlags200ResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'category': json['category'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['created_by_user']),
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'aliases': !exists(json, 'aliases') ? undefined : ((json['aliases'] as Array<any>).map(UpdateScreenerSettingRequestFromJSON)),
    };
}

export function FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(value?: FindAllScreenerAdmissionFlags200ResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'dob': value.dob,
        'category': value.category,
        'comment': value.comment,
        'created_at': value.created_at,
        'created_by_user': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value.created_by_user),
        'gender': value.gender,
        'aliases': value.aliases === undefined ? undefined : ((value.aliases as Array<any>).map(UpdateScreenerSettingRequestToJSON)),
    };
}

